// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar {
    color: #474747;
}

.p-2 {
    padding: .5rem;
}

.flex {
    display: flex;
}

.ml-auto {
    margin-left: auto;
}

.w-max {
    width: -moz-max-content;
    width: max-content;
}

.px-2 {
    padding-left: .5rem;
    padding-right: .5rem;
}

.text-sm {
    font-size: .875rem;
    line-height: 1.25rem;
}

.bg-slate-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}

.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.rounded-md {
    border-radius: .375rem;
}

.overflow-hidden {
    overflow: hidden;
}

.calendar-grid {
    display: grid;
}

.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}

.auto-rows-max {
    grid-auto-rows: max-content;
}

.w-\\[512px\\] {
    width: 512px;
}

.h-\\[445px\\] {
    height: 445px;
}

.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.grid-cols-3 {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
}

.grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    gap: 10px;
}

.grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    gap: 10px;
    display: grid;
}

.border-r-2 {
    border-right-width: 2px;
}

.mx-2 {
    margin-left: .5rem;
    margin-right: .5rem;
}

.auto-rows-max {
    grid-auto-rows: max-content;
}

.bg-secondaryDark {
    --tw-bg-opacity: 1;
    background-color: rgb(108 108 108 / var(--tw-bg-opacity));
}

.auto-rows-max {
    grid-auto-rows: max-content;
}

.h-\\[406px\\] {
    height: 406px;
}

.block {
    display: block;
}

.w-full {
    width: 100%;
}

.w-1\\/2 {
    width: 50%;
}

.rounded-full {
    border-radius: 9999px;
}

.p-4 {
    padding: 1rem;
}

.cursor-pointer {
    cursor: pointer;
}

.text-slate-200 {
    --tw-text-opacity: 1;
    color: rgb(209 213 219 / var(--tw-text-opacity));
}

.justify-between{
    justify-content: space-between;
}

/* ——— Date filter: redesigned calendar popover (dashboard-aligned) ——— */

.filter-calendar-root {
    position: relative;
    overflow: visible;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* Popover must stack above sticky dashboard header (z-index ~100) */
.filter-calendar-root.filter-calendar-root--open {
    z-index: 400;
}

.filter-calendar-trigger {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 12px 16px;
    flex-wrap: wrap;
    margin-left: auto;
    width: max-content;
    max-width: 100%;
    text-align: right;
    padding: 8px 10px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.18);
    transition: border-color 0.15s ease, background 0.15s ease;
}

.filter-calendar-trigger:hover {
    border-color: rgba(192, 159, 83, 0.35);
    background: rgba(0, 0, 0, 0.28);
}

.filter-calendar-trigger:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.75);
    outline-offset: 2px;
}

.filter-calendar-trigger__badge {
    flex-shrink: 0;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #f4f4f4;
    background: rgba(192, 159, 83, 0.35);
    border: 1px solid rgba(192, 159, 83, 0.45);
    padding: 6px 10px;
    border-radius: 8px;
}

.filter-calendar-trigger__dates {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    min-width: 0;
}

.filter-calendar-trigger__line {
    font-size: 0.8125rem;
    line-height: 1.35;
    color: rgba(230, 230, 230, 0.92);
}

.filter-calendar-trigger__line--demo {
    color: rgba(192, 159, 83, 0.95);
    font-weight: 600;
}

.filter-calendar-trigger__line--compare {
    font-size: 0.75rem;
    color: rgba(180, 180, 180, 0.95);
}

.filter-calendar-trigger__compare-kicker {
    margin-right: 6px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    font-size: 0.65rem;
    color: rgba(192, 159, 83, 0.9);
}

.filter-calendar-trigger__sep {
    margin: 0 0.35em;
    opacity: 0.55;
    font-weight: 400;
}

.filter-calendar-backdrop {
    display: none;
}

.filter-calendar-popover {
    position: absolute;
    z-index: 450;
    right: 0;
    top: calc(100% + 10px);
    width: min(520px, calc(100vw - 24px));
    /* Definite height so flex children (body + footer) get a real budget — avoids clipping presets/calendar/buttons */
    height: min(520px, calc(100vh - 80px));
    max-height: calc(100vh - 16px);
    max-height: min(calc(100vh - 16px), calc(100dvh - 16px));
    display: flex;
    flex-direction: column;
    border-radius: 14px;
    overflow: hidden;
    background: linear-gradient(165deg, rgb(48, 48, 50) 0%, rgb(34, 34, 36) 100%);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow:
        0 24px 48px rgba(0, 0, 0, 0.45),
        0 0 0 1px rgba(0, 0, 0, 0.2);
}

.filter-calendar-popover__body {
    display: grid;
    grid-template-columns: minmax(168px, 40%) minmax(0, 1fr);
    gap: 0;
    flex: 1 1 0%;
    min-height: 0;
    overflow: hidden;
    align-items: stretch;
}

.filter-calendar-presets__toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 12px 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    flex-shrink: 0;
}

.filter-calendar-compare-toggle__label {
    font-size: 0.8125rem;
    line-height: 1.3;
    color: rgba(220, 220, 220, 0.92);
    user-select: none;
}

.filter-calendar-compare-switch {
    position: relative;
    width: 44px;
    height: 24px;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.14);
    cursor: pointer;
    transition: background 0.15s ease;
}

.filter-calendar-compare-switch:hover {
    background: rgba(255, 255, 255, 0.2);
}

.filter-calendar-compare-switch--on {
    background: rgba(192, 159, 83, 0.55);
}

.filter-calendar-compare-switch--on:hover {
    background: rgba(192, 159, 83, 0.65);
}

.filter-calendar-compare-switch__thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
    transition: transform 0.15s ease;
}

.filter-calendar-compare-switch--on .filter-calendar-compare-switch__thumb {
    transform: translateX(20px);
}

.filter-calendar-compare-switch:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.85);
    outline-offset: 2px;
}

.filter-calendar-presets {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 10px 0;
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.2);
    min-height: 0;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.filter-calendar-preset {
    display: block;
    width: 100%;
    margin: 0;
    padding: 9px 12px 9px 14px;
    border: none;
    border-left: 3px solid transparent;
    background: transparent;
    color: rgba(220, 220, 220, 0.95);
    font-size: 0.8125rem;
    line-height: 1.3;
    text-align: left;
    cursor: pointer;
    transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.filter-calendar-preset:hover {
    background: rgba(192, 159, 83, 0.12);
    color: #fff;
}

.filter-calendar-preset--active {
    border-left-color: rgb(192, 159, 83);
    background: rgba(192, 159, 83, 0.18);
    color: #fff;
    font-weight: 600;
}

.filter-calendar-presets__compare-wrap {
    margin-top: 6px;
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.filter-calendar-presets__compare {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.filter-calendar-presets__compare-label {
    margin: 0 0 6px;
    padding: 0 12px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(160, 160, 160, 0.95);
}

.filter-calendar-popover__calendar-wrap {
    min-height: 0;
    min-width: 0;
    max-height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.filter-calendar-popover__calendar-wrap .filter-cal-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background: rgba(0, 0, 0, 0.12);
}

.filter-calendar-popover__footer {
    display: flex;
    flex-shrink: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background: rgb(34, 34, 36);
}

.filter-calendar-popover__btn {
    flex: 1;
    margin: 0;
    padding: 12px 16px;
    border: none;
    font-size: 0.875rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}

.filter-calendar-popover__btn--secondary {
    background: rgba(70, 70, 72, 0.95);
    color: rgba(240, 240, 240, 0.95);
}

.filter-calendar-popover__btn--secondary:hover {
    background: rgba(90, 90, 92, 1);
}

.filter-calendar-popover__btn--primary {
    background: rgb(192, 159, 83);
    color: #1a1a1a;
}

.filter-calendar-popover__btn--primary:hover {
    background: rgb(205, 175, 105);
}

@media screen and (max-width: 640px) {
    .filter-calendar-backdrop {
        display: block;
        position: fixed;
        inset: 0;
        z-index: 1195;
        background: rgba(0, 0, 0, 0.52);
        touch-action: none;
    }

    .filter-calendar-root.filter-calendar-root--open {
        z-index: 1200;
    }

    /* Full-viewport sheet: Apply / Cancel sit above home indicator (parent safe-area padding) */
    .filter-calendar-popover {
        position: fixed;
        left: 0;
        right: 0;
        top: env(safe-area-inset-top, 0px);
        bottom: 0;
        width: 100%;
        max-width: none;
        margin: 0;
        height: calc(100vh - env(safe-area-inset-top, 0px));
        height: calc(100dvh - env(safe-area-inset-top, 0px));
        max-height: calc(100vh - env(safe-area-inset-top, 0px));
        max-height: calc(100dvh - env(safe-area-inset-top, 0px));
        min-height: 0;
        border-radius: 16px 16px 0 0;
        z-index: 1201;
        padding-bottom: env(safe-area-inset-bottom, 0px);
        box-sizing: border-box;
        box-shadow: 0 -8px 40px rgba(0, 0, 0, 0.55);
    }

    .filter-calendar-popover__body {
        grid-template-columns: 1fr;
        grid-template-rows: minmax(0, min(200px, 32dvh)) minmax(0, 1fr);
        min-height: 0;
        flex: 1 1 auto;
        overflow: hidden;
    }

    .filter-calendar-presets {
        border-right: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        max-height: none;
        min-height: 0;
    }

    .filter-calendar-popover__calendar-wrap {
        max-height: none;
        min-height: 0;
    }

    .filter-calendar-popover__footer {
        flex-shrink: 0;
        box-shadow: 0 -10px 28px rgba(0, 0, 0, 0.4);
    }

    .filter-calendar-popover__btn {
        padding: 14px 16px;
        min-height: 48px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Filter/Styles/Filter.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,2EAA2E;IAC3E,iGAAiG;IACjG,uGAAuG;AAC3G;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,2DAA2D;IAC3D,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,8BAA8B;AAClC;;AAEA,yEAAyE;;AAEzE;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yFAAyF;AAC7F;;AAEA,oEAAoE;AACpE;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,0DAA0D;AAC9D;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;AACnC;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,oCAAoC;IACpC,0CAA0C;IAC1C,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,sBAAsB;IACtB,qCAAqC;IACrC,kHAAkH;IAClH,sCAAsC;IACtC,8BAA8B;IAC9B,wDAAwD;IACxD,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,6EAA6E;IAC7E,0CAA0C;IAC1C;;oCAEgC;AACpC;;AAEA;IACI,aAAa;IACb,wDAAwD;IACxD,MAAM;IACN,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;IACtB,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,eAAe;IACf,iDAAiD;IACjD,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,YAAY;IACZ,kCAAkC;IAClC,uBAAuB;IACvB,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,OAAO;IACP,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,QAAQ;QACR,aAAa;QACb,+BAA+B;QAC/B,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA,4FAA4F;IAC5F;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,kCAAkC;QAClC,SAAS;QACT,WAAW;QACX,eAAe;QACf,SAAS;QACT,mDAAmD;QACnD,oDAAoD;QACpD,uDAAuD;QACvD,wDAAwD;QACxD,aAAa;QACb,4BAA4B;QAC5B,aAAa;QACb,gDAAgD;QAChD,sBAAsB;QACtB,2CAA2C;IAC/C;;IAEA;QACI,0BAA0B;QAC1B,+DAA+D;QAC/D,aAAa;QACb,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,kDAAkD;QAClD,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,2CAA2C;IAC/C;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ","sourcesContent":[".calendar {\n    color: #474747;\n}\n\n.p-2 {\n    padding: .5rem;\n}\n\n.flex {\n    display: flex;\n}\n\n.ml-auto {\n    margin-left: auto;\n}\n\n.w-max {\n    width: -moz-max-content;\n    width: max-content;\n}\n\n.px-2 {\n    padding-left: .5rem;\n    padding-right: .5rem;\n}\n\n.text-sm {\n    font-size: .875rem;\n    line-height: 1.25rem;\n}\n\n.bg-slate-100 {\n    --tw-bg-opacity: 1;\n    background-color: rgb(241 245 249 / var(--tw-bg-opacity));\n}\n\n.shadow-md {\n    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);\n    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.rounded-md {\n    border-radius: .375rem;\n}\n\n.overflow-hidden {\n    overflow: hidden;\n}\n\n.calendar-grid {\n    display: grid;\n}\n\n.grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.auto-rows-max {\n    grid-auto-rows: max-content;\n}\n\n.w-\\[512px\\] {\n    width: 512px;\n}\n\n.h-\\[445px\\] {\n    height: 445px;\n}\n\n.grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n}\n\n.grid-cols-3 {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 10px;\n}\n\n.grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n    gap: 10px;\n}\n\n.grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;\n    gap: 10px;\n    display: grid;\n}\n\n.border-r-2 {\n    border-right-width: 2px;\n}\n\n.mx-2 {\n    margin-left: .5rem;\n    margin-right: .5rem;\n}\n\n.auto-rows-max {\n    grid-auto-rows: max-content;\n}\n\n.bg-secondaryDark {\n    --tw-bg-opacity: 1;\n    background-color: rgb(108 108 108 / var(--tw-bg-opacity));\n}\n\n.auto-rows-max {\n    grid-auto-rows: max-content;\n}\n\n.h-\\[406px\\] {\n    height: 406px;\n}\n\n.block {\n    display: block;\n}\n\n.w-full {\n    width: 100%;\n}\n\n.w-1\\/2 {\n    width: 50%;\n}\n\n.rounded-full {\n    border-radius: 9999px;\n}\n\n.p-4 {\n    padding: 1rem;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.text-slate-200 {\n    --tw-text-opacity: 1;\n    color: rgb(209 213 219 / var(--tw-text-opacity));\n}\n\n.justify-between{\n    justify-content: space-between;\n}\n\n/* ——— Date filter: redesigned calendar popover (dashboard-aligned) ——— */\n\n.filter-calendar-root {\n    position: relative;\n    overflow: visible;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* Popover must stack above sticky dashboard header (z-index ~100) */\n.filter-calendar-root.filter-calendar-root--open {\n    z-index: 400;\n}\n\n.filter-calendar-trigger {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n    gap: 12px 16px;\n    flex-wrap: wrap;\n    margin-left: auto;\n    width: max-content;\n    max-width: 100%;\n    text-align: right;\n    padding: 8px 10px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.18);\n    transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.filter-calendar-trigger:hover {\n    border-color: rgba(192, 159, 83, 0.35);\n    background: rgba(0, 0, 0, 0.28);\n}\n\n.filter-calendar-trigger:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.75);\n    outline-offset: 2px;\n}\n\n.filter-calendar-trigger__badge {\n    flex-shrink: 0;\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #f4f4f4;\n    background: rgba(192, 159, 83, 0.35);\n    border: 1px solid rgba(192, 159, 83, 0.45);\n    padding: 6px 10px;\n    border-radius: 8px;\n}\n\n.filter-calendar-trigger__dates {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n    min-width: 0;\n}\n\n.filter-calendar-trigger__line {\n    font-size: 0.8125rem;\n    line-height: 1.35;\n    color: rgba(230, 230, 230, 0.92);\n}\n\n.filter-calendar-trigger__line--demo {\n    color: rgba(192, 159, 83, 0.95);\n    font-weight: 600;\n}\n\n.filter-calendar-trigger__line--compare {\n    font-size: 0.75rem;\n    color: rgba(180, 180, 180, 0.95);\n}\n\n.filter-calendar-trigger__compare-kicker {\n    margin-right: 6px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    font-size: 0.65rem;\n    color: rgba(192, 159, 83, 0.9);\n}\n\n.filter-calendar-trigger__sep {\n    margin: 0 0.35em;\n    opacity: 0.55;\n    font-weight: 400;\n}\n\n.filter-calendar-backdrop {\n    display: none;\n}\n\n.filter-calendar-popover {\n    position: absolute;\n    z-index: 450;\n    right: 0;\n    top: calc(100% + 10px);\n    width: min(520px, calc(100vw - 24px));\n    /* Definite height so flex children (body + footer) get a real budget — avoids clipping presets/calendar/buttons */\n    height: min(520px, calc(100vh - 80px));\n    max-height: calc(100vh - 16px);\n    max-height: min(calc(100vh - 16px), calc(100dvh - 16px));\n    display: flex;\n    flex-direction: column;\n    border-radius: 14px;\n    overflow: hidden;\n    background: linear-gradient(165deg, rgb(48, 48, 50) 0%, rgb(34, 34, 36) 100%);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    box-shadow:\n        0 24px 48px rgba(0, 0, 0, 0.45),\n        0 0 0 1px rgba(0, 0, 0, 0.2);\n}\n\n.filter-calendar-popover__body {\n    display: grid;\n    grid-template-columns: minmax(168px, 40%) minmax(0, 1fr);\n    gap: 0;\n    flex: 1 1 0%;\n    min-height: 0;\n    overflow: hidden;\n    align-items: stretch;\n}\n\n.filter-calendar-presets__toggle-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 8px 12px 10px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    flex-shrink: 0;\n}\n\n.filter-calendar-compare-toggle__label {\n    font-size: 0.8125rem;\n    line-height: 1.3;\n    color: rgba(220, 220, 220, 0.92);\n    user-select: none;\n}\n\n.filter-calendar-compare-switch {\n    position: relative;\n    width: 44px;\n    height: 24px;\n    flex-shrink: 0;\n    margin: 0;\n    padding: 0;\n    border: none;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.14);\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.filter-calendar-compare-switch:hover {\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.filter-calendar-compare-switch--on {\n    background: rgba(192, 159, 83, 0.55);\n}\n\n.filter-calendar-compare-switch--on:hover {\n    background: rgba(192, 159, 83, 0.65);\n}\n\n.filter-calendar-compare-switch__thumb {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #fff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);\n    transition: transform 0.15s ease;\n}\n\n.filter-calendar-compare-switch--on .filter-calendar-compare-switch__thumb {\n    transform: translateX(20px);\n}\n\n.filter-calendar-compare-switch:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.85);\n    outline-offset: 2px;\n}\n\n.filter-calendar-presets {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 10px 0;\n    border-right: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.2);\n    min-height: 0;\n    max-height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.filter-calendar-preset {\n    display: block;\n    width: 100%;\n    margin: 0;\n    padding: 9px 12px 9px 14px;\n    border: none;\n    border-left: 3px solid transparent;\n    background: transparent;\n    color: rgba(220, 220, 220, 0.95);\n    font-size: 0.8125rem;\n    line-height: 1.3;\n    text-align: left;\n    cursor: pointer;\n    transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n}\n\n.filter-calendar-preset:hover {\n    background: rgba(192, 159, 83, 0.12);\n    color: #fff;\n}\n\n.filter-calendar-preset--active {\n    border-left-color: rgb(192, 159, 83);\n    background: rgba(192, 159, 83, 0.18);\n    color: #fff;\n    font-weight: 600;\n}\n\n.filter-calendar-presets__compare-wrap {\n    margin-top: 6px;\n    padding-top: 10px;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.filter-calendar-presets__compare {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.filter-calendar-presets__compare-label {\n    margin: 0 0 6px;\n    padding: 0 12px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(160, 160, 160, 0.95);\n}\n\n.filter-calendar-popover__calendar-wrap {\n    min-height: 0;\n    min-width: 0;\n    max-height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.filter-calendar-popover__calendar-wrap .filter-cal-scroll {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    background: rgba(0, 0, 0, 0.12);\n}\n\n.filter-calendar-popover__footer {\n    display: flex;\n    flex-shrink: 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgb(34, 34, 36);\n}\n\n.filter-calendar-popover__btn {\n    flex: 1;\n    margin: 0;\n    padding: 12px 16px;\n    border: none;\n    font-size: 0.875rem;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.filter-calendar-popover__btn--secondary {\n    background: rgba(70, 70, 72, 0.95);\n    color: rgba(240, 240, 240, 0.95);\n}\n\n.filter-calendar-popover__btn--secondary:hover {\n    background: rgba(90, 90, 92, 1);\n}\n\n.filter-calendar-popover__btn--primary {\n    background: rgb(192, 159, 83);\n    color: #1a1a1a;\n}\n\n.filter-calendar-popover__btn--primary:hover {\n    background: rgb(205, 175, 105);\n}\n\n@media screen and (max-width: 640px) {\n    .filter-calendar-backdrop {\n        display: block;\n        position: fixed;\n        inset: 0;\n        z-index: 1195;\n        background: rgba(0, 0, 0, 0.52);\n        touch-action: none;\n    }\n\n    .filter-calendar-root.filter-calendar-root--open {\n        z-index: 1200;\n    }\n\n    /* Full-viewport sheet: Apply / Cancel sit above home indicator (parent safe-area padding) */\n    .filter-calendar-popover {\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: env(safe-area-inset-top, 0px);\n        bottom: 0;\n        width: 100%;\n        max-width: none;\n        margin: 0;\n        height: calc(100vh - env(safe-area-inset-top, 0px));\n        height: calc(100dvh - env(safe-area-inset-top, 0px));\n        max-height: calc(100vh - env(safe-area-inset-top, 0px));\n        max-height: calc(100dvh - env(safe-area-inset-top, 0px));\n        min-height: 0;\n        border-radius: 16px 16px 0 0;\n        z-index: 1201;\n        padding-bottom: env(safe-area-inset-bottom, 0px);\n        box-sizing: border-box;\n        box-shadow: 0 -8px 40px rgba(0, 0, 0, 0.55);\n    }\n\n    .filter-calendar-popover__body {\n        grid-template-columns: 1fr;\n        grid-template-rows: minmax(0, min(200px, 32dvh)) minmax(0, 1fr);\n        min-height: 0;\n        flex: 1 1 auto;\n        overflow: hidden;\n    }\n\n    .filter-calendar-presets {\n        border-right: none;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n        max-height: none;\n        min-height: 0;\n    }\n\n    .filter-calendar-popover__calendar-wrap {\n        max-height: none;\n        min-height: 0;\n    }\n\n    .filter-calendar-popover__footer {\n        flex-shrink: 0;\n        box-shadow: 0 -10px 28px rgba(0, 0, 0, 0.4);\n    }\n\n    .filter-calendar-popover__btn {\n        padding: 14px 16px;\n        min-height: 48px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
